import { Component } from '@angular/core';

@Component({
  selector: 'app-fix-media',
  templateUrl: './fix-media.component.html',
  styleUrl: './fix-media.component.scss'
})
export class FixMediaComponent {

}
